import { FC, useRef, useState} from "react"
import { AgGridColumn, AgGridReact } from "ag-grid-react"
import '../../../ag-grid.css'
import '../../../ag-theme-alpine.css'
import { Checkbox } from "primereact/checkbox";
import { Tag } from 'primereact/tag';
import { TfiEye } from "react-icons/tfi";
import { useHistory } from "react-router-dom";
import { HiOutlineEyeSlash } from "react-icons/hi2";
import { warning } from "../../../utils/notifications";


export const ScenarioRecoveryTable:FC<any> = (props) => {

    const gridRef :any= useRef();

    const history:any = useHistory()


    const {data,selectedRows, setSelectedRows,loading, setDisabledDesactivar, setDisabledRestaurar, setDisabledEliminar} = props

    

    const [checked, setChecked] = useState<boolean>(false);

    const forEachCustom = (items_filtered:any,activos:any,inactivos:any) => {
        items_filtered.forEach((item:any) => {
            if(item.borrado) {
                inactivos.push(item)
            } else {
                activos.push(item)
            }
        })
        return [activos,inactivos]
    }


    const checkBoxComponent = (params:any) => {

        
        const handleCheckboxHeader = (e:any) => {
            let items_filtered = getFilteredRowData()
            let activos:any = []
            let inactivos:any = []
            if(e.checked) {
                let ids = items_filtered.map((dt:any) => dt.id_scenario)
                setSelectedRows(ids)
            } else {
                setSelectedRows([]) 
            }

            let response = forEachCustom(items_filtered,activos,inactivos)
            activos = response[0]
            inactivos = response[1]
            
            if(activos.length === 0 && inactivos.length > 0) {
                setDisabledDesactivar(true)
                setDisabledRestaurar(false)
                setDisabledEliminar(false)
            } else if(activos.length > 0 && inactivos.length === 0) {
                setDisabledDesactivar(false)
                setDisabledRestaurar(true)
                setDisabledEliminar(true)
            } else {
                setDisabledRestaurar(true)
                setDisabledDesactivar(true)
                setDisabledEliminar(true)
            }
            
            setChecked(e.checked)
            gridRef?.current?.api?.redrawRows()
        }

        return (
            <Checkbox onChange={handleCheckboxHeader} checked={checked} disabled={loading}></Checkbox>
        )
    }

    const checkBoxRenderer = (params:any) => {

        const handleClickRow = (e:any) => {
            let aux:any[] = []
            let activos:any[] = []
            let inactivos:any = []
            if(e.checked) {
                aux = selectedRows
                aux.push(params.data.id_scenario)
                setSelectedRows(aux)
            } else {
               
                aux = selectedRows.filter((sr:any) => sr !== params.data.id_scenario)
                setSelectedRows(aux)
            }
            let items_filtered = getFilteredRowData()
            if(items_filtered.length === aux.length) {
                setChecked(true)
            } else {
                setChecked(false)
            }
           
            let items_a_filtrar = items_filtered.filter((i:any) => aux.includes(i.id_scenario) )

            let response = forEachCustom(items_a_filtrar,activos,inactivos)
            activos = response[0]
            inactivos = response[1]

             if(activos.length === 0 && inactivos.length > 0) {
                setDisabledDesactivar(true)
                setDisabledRestaurar(false)
                setDisabledEliminar(false)
            } else if(activos.length > 0 && inactivos.length === 0) {
                setDisabledDesactivar(false)
                setDisabledRestaurar(true)
                setDisabledEliminar(true)
            } else {
                setDisabledRestaurar(true)
                setDisabledDesactivar(true)
                setDisabledEliminar(true)
            }
            gridRef?.current?.api?.redrawRows()
            
        }

       
        return (
            <Checkbox onChange={handleClickRow} checked={selectedRows.includes(params.data.id_scenario)} disabled={loading}></Checkbox>
        )
    }



    const getFilteredRowData = () => {
        const gridApi = gridRef.current.api;
        const filteredRowData:any[] = [];
      
        if (gridApi) {
          gridApi.forEachNodeAfterFilterAndSort((node:any) => {
            filteredRowData.push(node.data);
          });
        }
      
        return filteredRowData;
      };

    const statusCellRenderer = (params:any) => {
        if(params.value === true) {
            return (
                <Tag severity="danger" className="tag-status" value="Desactivado"></Tag>
            )
        } 
         return (
            <Tag severity="success" className="tag-status"  value="Activado"></Tag>
         )
    }

    const handleFilterStatus = (params:any) => {
        if(params.data.borrado === true) {
            return 'Desactivado'
        } else {
            return 'Activado'
        }
    }

    const viewScenarioRenderer = (params:any) => {
        if(!params.data.borrado) {
            return (
                <TfiEye style={{cursor:'pointer'}} size={20} onClick={() => history.push(`/scenario_view/${params.data.id_scenario}/${params.data.id_scenario}`)} />
            )
        } 

        return <HiOutlineEyeSlash  style={{cursor:'pointer'}} size={20} onClick={() => warning("Restaura el escenario para ver su información")} />
        
    }
    
    const handleCellStyle = (params:any) => {
        if(selectedRows.includes(params.data.id_scenario)) {
            return {backgroundColor: 'lightcoral',color: 'white',fontWeight:'bold',height:'100%',border:'1px solid #dee2e6'} 
        }
        return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',height:'100%',border:'1px solid #dee2e6'} 
    }


    return (
        <div className="ag-theme-alpine" style={{display:'flex',flexDirection:'column', height:'90%', width: '95%' }}>

            <AgGridReact
                ref={gridRef}
                rowSelection={'multiple'}
                suppressRowClickSelection={true}
                
                headerHeight={30}
                getRowHeight={() => 30}
                rowData={
                    data
                    }
                    enableCellTextSelection>
                <AgGridColumn   flex={1} hide  field={"id"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"}  headerCheckboxSelectionFilteredOnly cellClass={"checkbox-table"}  headerComponent={checkBoxComponent} cellRenderer={checkBoxRenderer}  maxWidth={90} ></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"} filter suppressNavigable={true} sortable flex={1} headerName={"Escenario ID"} field={"id_scenario"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"} filter sortable  suppressNavigable={true}   flex={1} headerName={"Escenario"} field={"name_scenario"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"} filter   suppressNavigable={true} sortable   flex={1} headerName={"Fecha creación"} field={"created_at"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"}  filter suppressNavigable={true} sortable  flex={1} headerName={"Estado"} filterValueGetter={handleFilterStatus} cellRenderer={statusCellRenderer} field={"borrado"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"} filter  suppressNavigable={true} sortable  flex={1} headerName={"Fecha desactivado"} field={"deleted_at"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"}  suppressNavigable={true} sortable  maxWidth={90} cellRenderer={viewScenarioRenderer} ></AgGridColumn>

            </AgGridReact>
        </div>
    )
}